(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    

(()=>{
const motion=matchMedia('(prefers-reduced-motion: reduce)');
const instances=new Map();
const clamp=n=>Math.max(0,Math.min(1,n));
function init(root){
 const heroes=[...(root.matches?.('.tk-gentle-hero')?[root]:root.querySelectorAll('.tk-gentle-hero'))];
 heroes.forEach(hero=>{
 if(instances.has(hero))return;
 const stage=hero.querySelector('.tk-scroll-stage');
 const day=hero.querySelector('.tk-phase-day');
 const night=hero.querySelector('.tk-phase-night');
 const image=hero.querySelector('img');
 const content=hero.querySelector('.hero-content');
 let frame=0,top=72,height=640;
 function measure(){
  top=Math.round(document.querySelector('#site-header')?.getBoundingClientRect().height||0);
  const viewport=document.documentElement.clientHeight;
  height=Math.max(viewport-top-36,content.offsetHeight+(hero.querySelector('.hero-bg')?.offsetHeight||0)+16);
  hero.style.setProperty('--tk-top',top+'px');
  hero.style.setProperty('--tk-stage-h',height+'px');
  hero.classList.toggle('tk-scroll-active',!motion.matches);
  stage.style.top=Math.min(top,viewport-height-36)+'px';
  schedule();
 }
 function update(){
  frame=0;
  const active=!motion.matches;
  const progress=active?clamp((-hero.getBoundingClientRect().top+top)/Math.max(1,hero.offsetHeight-height-36)):0;
  hero.style.setProperty('--tk-p',progress.toFixed(4));
  const eased=progress*progress*(3-2*progress);
  hero.style.setProperty('--tk-zoom',String(1+eased*.32));
  const reveal=clamp((progress-.18)/.5);
  if(active){
   day.style.opacity=String(1-reveal);
   day.style.filter='blur('+(reveal*5)+'px)';
   night.style.opacity=String(reveal);
   night.style.clipPath='inset(0 '+((1-reveal)*100)+'% 0 0)';
  }else{
   for(const el of [day,night]){el.style.opacity='';el.style.filter='';el.style.clipPath=''}
   stage.style.top='';
  }
 }
 function schedule(){if(!frame)frame=requestAnimationFrame(update)}
 addEventListener('scroll',schedule,{passive:true});
 addEventListener('resize',measure,{passive:true});
 addEventListener('pageshow',measure);
 motion.addEventListener('change',measure);
 image?.addEventListener('load',measure);
 const resize=new ResizeObserver(measure);resize.observe(content);if(image)resize.observe(image);
 instances.set(hero,()=>{cancelAnimationFrame(frame);resize.disconnect();removeEventListener('scroll',schedule);removeEventListener('resize',measure);removeEventListener('pageshow',measure);motion.removeEventListener('change',measure);image?.removeEventListener('load',measure)});
 measure();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
document.addEventListener('shopify:section:load',e=>init(e.target));
document.addEventListener('shopify:section:unload',e=>{for(const [hero,cleanup]of instances)if(e.target.contains(hero)){cleanup();instances.delete(hero)}});
})();

  } catch(e) { console.error(e); }
})();
})();
